import { GTMEvent } from './GTMEvent'

export const linkClick = (
  linkName: string,
  linkCategory: string,
  linkType?: 'internal' | 'external',
): GTMEvent[] => [{ event: 'linkClick', linkName, linkCategory, linkType }]
